<template>
    <BaseCard data-spec-class="card-metric">
        <div class="flex items-center justify-between gap-2">
            <dt
                data-spec-id="metric-title"
                class="truncate font-medium text-tertiary"
            >
                <slot name="title">{{ title }}</slot>
            </dt>
            <div
                v-if="$slots.trailing"
                data-spec-id="metric-trailing"
                class="shrink-0"
            >
                <slot name="trailing"> </slot>
            </div>
        </div>
        <div class="flex items-center gap-2">
            <dd
                data-spec-id="metric-value"
                class="relative mt-1 overflow-hidden text-2xl font-semibold tracking-tight text-secondary"
            >
                <BaseTransitionSlide>
                    <span
                        :key="value"
                        class="block"
                    >
                        <slot name="value">{{ value }}</slot>
                    </span>
                </BaseTransitionSlide>
            </dd>

            <BaseSpinner
                :is-active="isLoading"
                data-spec-id="metric-spinner"
                :size="SizeAll.Huge"
            />
        </div>
    </BaseCard>
</template>

<script setup lang="ts">
import { SizeAll } from '@/types';
import BaseTransitionSlide from './BaseTransitionSlide.vue';
import BaseCard from './BaseCard.vue';
import BaseSpinner from './BaseSpinner.vue';

defineProps<{
    title: string;
    value: string;
    isLoading?: boolean;
}>();
</script>
